// #665 — la population de la commune, et ce qu'elle est.
//
// Relevé le 10/10 sur Besançon : la vue d'ensemble affichait 118 489, la fiche d'un quartier
// de la carte « Commune : 120 057 ». Les deux sont justes — population légale 2023 d'un côté,
// somme des quartiers du recensement 2022 de l'autre — mais rien ne le disait. Le serveur
// sert désormais la notion et le millésime (`population_reference`, backend
// `population_reference.py`) ; ces trois écrans les écrivent. Le libellé vient TOUJOURS du
// serveur : sans lui (serveur antérieur), l'affichage reste celui d'avant, sans année devinée.
import type { CommuneMeta } from './types'

const nombre = (n: number) => n.toLocaleString('fr-FR')
const majuscule = (s: string) => s.charAt(0).toUpperCase() + s.slice(1)

/** En-tête de l'observatoire : la notion et l'année en clair (un `title` ne s'ouvre pas au
    doigt — revue Codex), la date d'entrée en vigueur au survol. */
export function populationEnTete(c: CommuneMeta): { texte: string; titre: string | undefined } | null {
  if (c.population == null) return null
  const ref = c.population_reference
  return {
    texte: `${nombre(c.population)} hab${ref?.libelle_court ? ` (${ref.libelle_court})` : ''}`,
    titre: ref?.libelle ? majuscule(ref.libelle) : undefined,
  }
}

/** Héros de la vue d'ensemble : la notion et l'année en clair, en version courte. */
export function populationHeros(c: CommuneMeta): string | null {
  if (c.population == null) return null
  const court = c.population_reference?.libelle_court
  return `${nombre(c.population)} habitants${court ? ` (${court})` : ''}`
}

/** Couverture imprimée : le libellé complet — un PDF n'a pas de survol. */
export function populationCouverture(c: CommuneMeta): string | null {
  if (c.population == null) return null
  const libelle = c.population_reference?.libelle
  return `${nombre(c.population)} habitants${libelle ? ` (${libelle})` : ''}`
}
